import type { IconSvgObject } from './types';

const WomanIcon: IconSvgObject = [
  ["path", { d: "M13.9999 22L14.0005 15.9996L16.9999 16L16.9998 15L14.211 9.82071C13.773 9.00726 12.9237 8.5 11.9998 8.5C11.0759 8.5 10.2267 9.00726 9.78867 9.82071L6.99982 15V15.9996H10.0005V22H13.9999Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.9998 4C13.9998 5.10457 13.1044 6 11.9998 6C10.8952 6 9.99982 5.10457 9.99982 4C9.99982 2.89543 10.8952 2 11.9998 2C13.1044 2 13.9998 2.89543 13.9998 4Z", stroke: "currentColor", strokeLinecap: "square", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default WomanIcon;
